import React from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames';

function PhoneNumber(props) {
  let newProps = { ...props };
  delete newProps['setfieldvalue']; // Here we can delete the props not being used

  return (
    <InputMask
      className={classNames('form-control', 'mb-2', {
        'is-invalid': props.error
      })}
      {...newProps}
      mask="(999) 999-9999"
      maskChar=" "
    />
  );
}

export default PhoneNumber;
